export default function Common() {
  return [
    "TagSvg",
    "TimeSvg",
    "DiscriptionSvg",
    "DetailsSvg",
    "AboutSvg",
    "CollectionSvg",
    "BellSvg",
    "validateEmail",
    "validateRequired",
    "validatePassword",
    "setCookie",
    "getCookie",
    "checkCookie",
    "deleteCookie",
  ];
}

// components -----------------------------
export const TagSvg = ({ color, size, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 61 61"
    fill="none"
    className={className ? className : null}
  >
    <path
      d="M60.3001 25.114C60.2483 24.6172 60.1616 23.7331 60.1058 23.1511C60.0471 22.5679 59.9157 21.2301 59.8114 20.1746C59.7071 19.1191 59.5507 17.5332 59.4639 16.6467C59.3772 15.7602 59.2594 14.5723 59.2039 14.0082C59.1483 13.4436 58.9925 11.8541 58.857 10.4797C58.3987 5.78896 58.4294 6.06464 58.2924 5.61495C57.8011 3.97756 56.2502 2.6521 54.593 2.4499C54.3833 2.42465 53.2957 2.34446 49.1184 2.03496C48.4326 1.98446 46.739 1.85887 45.3524 1.75804C43.9658 1.65421 41.6086 1.47787 40.1115 1.36868C38.6144 1.25649 36.7485 1.12024 35.9648 1.06184C34.5385 0.954852 34.1208 0.944543 33.6264 0.9993C32.2426 1.15585 30.6441 1.79185 29.575 2.60791C29.152 2.93188 29.2487 2.83238 23.5004 8.66512C22.6657 9.51274 20.6093 11.594 18.9303 13.2929C17.2507 14.9919 15.1641 17.1071 14.2956 17.9917C13.4241 18.8805 12.6956 19.6166 12.6741 19.6288C12.6526 19.6416 11.9395 20.3649 11.0828 21.2344C10.2297 22.1038 8.15205 24.2093 6.46354 25.918C1.71361 30.723 1.28534 31.1641 1.10485 31.4421C0.636484 32.1602 0.415129 32.9667 0.464505 33.7834C0.506843 34.5078 0.716032 35.1289 1.12558 35.7447C1.2971 36.0038 2.02706 36.7265 5.6262 40.2089C9.22171 43.6883 12.7523 47.1073 15.1437 49.4235C16.0318 50.286 18.1714 52.3561 19.8949 54.0235C21.6213 55.6932 23.6244 57.6334 24.3506 58.3351C25.7452 59.6857 25.9282 59.8409 26.468 60.0898C27.6443 60.6389 29.0379 60.5614 30.1637 59.8857C30.5148 59.6789 30.7061 59.5016 31.7693 58.4276C33.1416 57.0393 35.5954 54.5546 37.4025 52.7221C38.2284 51.8866 39.6102 50.4856 40.4699 49.6167C44.4508 45.5847 45.2921 44.731 46.7403 43.2651C47.5941 42.401 49.6985 40.2707 51.4172 38.528C54.1873 35.7266 56.4584 33.4251 58.0229 31.8354C58.5876 31.2608 58.8055 30.9968 59.0897 30.5484C59.862 29.324 60.3429 27.8071 60.3765 26.4645C60.3882 26.1241 60.3685 25.8105 60.3001 25.114ZM51.5225 13.7105C51.0668 14.6547 50.251 15.3185 49.2155 15.5977C47.4184 16.0787 45.5024 15.0526 44.9174 13.2933C44.7807 12.8832 44.7447 12.6622 44.7395 12.205C44.7328 11.6092 44.8292 11.1599 45.0755 10.6531C45.5763 9.61542 46.527 8.8895 47.673 8.67081C47.7592 8.65484 48.0627 8.64484 48.3484 8.64463C48.7906 8.64926 48.9168 8.65984 49.1629 8.72428C50.4543 9.0506 51.4383 10.0074 51.7715 11.2595C51.9896 12.0863 51.9066 12.9201 51.5225 13.7105Z"
      fill={color}
    />
  </svg>
);

export const TimeSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 35 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.8299 34.0013L29.6062 29.6754C31.3564 27.4035 32.4896 24.6917 32.8897 21.8182C33.2899 18.9448 32.9424 16.0132 31.8831 13.3241C32.5081 12.5523 32.9796 11.6609 33.2709 10.7008C33.5622 9.74082 33.6675 8.73096 33.5808 7.7289C33.4941 6.72685 33.2172 5.75225 32.7657 4.86072C32.3142 3.9692 31.6971 3.17823 30.9496 2.53297C30.2021 1.8877 29.3388 1.40078 28.409 1.10001C27.4793 0.799234 26.5012 0.690497 25.5308 0.780005C24.5603 0.869512 23.6164 1.15551 22.753 1.62167C21.8896 2.08784 21.1236 2.72503 20.4987 3.49688C18.2502 2.97102 15.9164 2.97102 13.668 3.49688C12.976 2.63137 12.1063 1.93555 11.1218 1.45982C10.1373 0.984083 9.06268 0.740327 7.97573 0.746197C6.56339 0.743776 5.17997 1.15938 3.98933 1.94378C2.79869 2.72818 1.85073 3.84851 1.25774 5.17206C0.664745 6.49561 0.451564 7.96692 0.643449 9.41172C0.835333 10.8565 1.42424 12.2143 2.34042 13.3241C1.27329 16.0081 0.916485 18.9368 1.30658 21.8101C1.69668 24.6833 2.81964 27.3978 4.56039 29.6754L0.336751 34.0013C0.230046 34.1105 0.145352 34.2405 0.0875545 34.3838C0.029757 34.527 0 34.6807 0 34.8359C0 34.991 0.029757 35.1447 0.0875545 35.2879C0.145352 35.4312 0.230046 35.5612 0.336751 35.6705C0.442584 35.7807 0.568498 35.8681 0.707228 35.9278C0.845959 35.9875 0.99476 36.0182 1.14505 36.0182C1.29534 36.0182 1.44414 35.9875 1.58287 35.9278C1.7216 35.8681 1.84751 35.7807 1.95335 35.6705L6.06314 31.4151C9.02145 34.3629 12.9722 36.0102 17.0833 36.0102C21.1945 36.0102 25.1452 34.3629 28.1035 31.4151L32.2133 35.6705C32.3191 35.7807 32.445 35.8681 32.5838 35.9278C32.7225 35.9875 32.8713 36.0182 33.0216 36.0182C33.1719 36.0182 33.3207 35.9875 33.4594 35.9278C33.5981 35.8681 33.724 35.7807 33.8299 35.6705C33.9366 35.5612 34.0213 35.4312 34.0791 35.2879C34.1369 35.1447 34.1666 34.991 34.1666 34.8359C34.1666 34.6807 34.1369 34.527 34.0791 34.3838C34.0213 34.2405 33.9366 34.1105 33.8299 34.0013ZM26.1909 3.09721C27.5487 3.10031 28.85 3.65863 29.8101 4.64998C30.7702 5.64133 31.3109 6.985 31.3139 8.38699C31.3191 9.28368 31.0995 10.1665 30.6764 10.9496C30.5625 10.7498 30.4259 10.5617 30.3007 10.3736C28.8873 8.19766 26.9851 6.407 24.7564 5.15434L24.6084 5.07206C24.2441 4.87614 23.8647 4.68806 23.47 4.50782L23.1854 4.37851L22.9805 4.27271C23.8903 3.51591 25.0225 3.10135 26.1909 3.09721ZM7.97573 3.09721C9.14408 3.10135 10.2763 3.51591 11.1862 4.27271L10.9812 4.36676L10.6966 4.49606C10.3096 4.67631 9.93007 4.86439 9.55818 5.0603L9.41018 5.14259C7.18696 6.39346 5.28895 8.17986 3.87732 10.3501C3.75209 10.5382 3.61548 10.7262 3.50163 10.9261C3.07834 10.151 2.8549 9.27676 2.85272 8.38699C2.85573 6.985 3.39644 5.64133 4.35654 4.64998C5.31664 3.65863 6.61795 3.10031 7.97573 3.09721ZM17.0833 33.6604C13.4601 33.6604 9.98527 32.1742 7.42327 29.5288C4.86126 26.8834 3.42194 23.2955 3.42194 19.5543C3.4217 17.3116 3.94499 15.102 4.94746 13.1125L5.18654 12.6306C5.34592 12.3602 5.5053 12.0781 5.67607 11.8077L5.88099 11.5021C6.08591 11.2082 6.29083 10.9026 6.51852 10.6322L6.62098 10.5029C7.92646 8.9139 9.55514 7.64159 11.3911 6.77654L11.9603 6.50618L12.5181 6.29458L13.3834 6.00071C15.8371 5.26405 18.4433 5.26405 20.8971 6.00071L21.7623 6.29458L22.3202 6.50618L22.8894 6.77654C24.6843 7.65616 26.273 8.92754 27.5456 10.5029L27.6481 10.6322C27.8758 10.9026 28.0807 11.2082 28.2856 11.5021L28.4906 11.8077C28.6613 12.0781 28.8207 12.3602 28.9801 12.6306L29.2192 13.1125C30.2216 15.102 30.7449 17.3116 30.7447 19.5543C30.7447 23.2955 29.3054 26.8834 26.7434 29.5288C24.1814 32.1742 20.7065 33.6604 17.0833 33.6604Z"
      fill="#ec004f"
    />
    <path
      d="M18.2159 18.4593V11.9825C18.2159 11.6752 18.0904 11.3805 17.867 11.1632C17.6436 10.9459 17.3406 10.8239 17.0247 10.8239C16.7087 10.8239 16.4057 10.9459 16.1823 11.1632C15.9589 11.3805 15.8334 11.6752 15.8334 11.9825V18.9343C15.8325 19.0868 15.8625 19.2379 15.9218 19.3791C15.9811 19.5203 16.0685 19.6487 16.1789 19.7569L21.2298 24.7275C21.3414 24.8451 21.4768 24.9389 21.6275 25.0031C21.7782 25.0673 21.9409 25.1005 22.1054 25.1005C22.2699 25.1005 22.4327 25.0673 22.5834 25.0031C22.7341 24.9389 22.8694 24.8451 22.981 24.7275C23.0927 24.6198 23.1813 24.4916 23.2418 24.3504C23.3022 24.2092 23.3334 24.0578 23.3334 23.9048C23.3334 23.7519 23.3022 23.6004 23.2418 23.4592C23.1813 23.3181 23.0927 23.1899 22.981 23.0822L18.2159 18.4593Z"
      fill="#ec004f"
    />
  </svg>
);

export const DiscriptionSvg = ({ color, size, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 55 39"
    fill="none"
    className={className ? className : null}
  >
    <line
      x1="4"
      y1="4"
      x2="51"
      y2="4"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="4"
      y1="19.125"
      x2="51"
      y2="19.125"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="4"
      y1="34.25"
      x2="23.5"
      y2="34.25"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);

export const DetailsSvg = ({ color, size, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 58 50"
    fill="none"
    className={className ? className : null}
  >
    <line
      x1="33"
      y1="11"
      x2="52.5"
      y2="11"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <rect width="20" height="20" rx="3" fill={color} />
    <line
      x1="34"
      y1="41"
      x2="53.5"
      y2="41"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <rect x="1" y="30" width="20" height="20" rx="3" fill={color} />
  </svg>
);

export const AboutSvg = ({ color, size, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 54 50"
    fill="none"
    className={className ? className : null}
  >
    <line
      x1="30"
      y1="44"
      x2="49.5"
      y2="44"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="30"
      y1="5"
      x2="49.5"
      y2="5"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <line
      x1="30"
      y1="24"
      x2="49.5"
      y2="24"
      stroke={color}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <rect width="20" height="50" rx="3" fill={color} />
  </svg>
);

export const CollectionSvg = ({ color, size, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 55 55"
    fill="none"
    className={className ? className : null}
  >
    <path
      d="M6.8219 0C3.04253 0 0 3.06621 0 6.87501V18.9062C0 22.715 3.04253 25.7812 6.8219 25.7812H18.7604C22.5399 25.7812 25.5824 22.715 25.5824 18.9062V6.87501C25.5824 3.06621 22.5399 0 18.7604 0H6.8219ZM35.8154 0C32.0359 0 28.9934 3.06621 28.9934 6.87501V18.9062C28.9934 22.715 32.0359 25.7812 35.8154 25.7812H47.7538C51.5333 25.7812 54.5758 22.715 54.5758 18.9062V6.87501C54.5758 3.06621 51.5333 0 47.7538 0H35.8154ZM12.7912 29.2188C5.70479 29.2188 0 34.9678 0 42.1093C0 49.2507 5.70479 55 12.7912 55C19.8775 55 25.5824 49.2507 25.5824 42.1093C25.5824 34.9678 19.8775 29.2188 12.7912 29.2188ZM35.8154 29.2188C32.0359 29.2188 28.9934 32.285 28.9934 36.0938V48.125C28.9934 51.9338 32.0359 55 35.8154 55H47.7538C51.5333 55 54.5758 51.9338 54.5758 48.125V36.0938C54.5758 32.285 51.5333 29.2188 47.7538 29.2188H35.8154Z"
      fill={color}
    />
  </svg>
);

export const BellSvg = ({ color, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    x="0px"
    width={size}
    height={size}
    y="0px"
    fill={color}
  >
    <g data-name="33">
      <path d="M81.3,72.441l-.609-.614A17.545,17.545,0,0,1,75.56,59.386V41.346A25.574,25.574,0,0,0,58.649,17.288v-3.7a8.553,8.553,0,1,0-17.105,0v3.639a25.558,25.558,0,0,0-17.1,24.124v18.04a17.545,17.545,0,0,1-5.128,12.441l-.609.614a3.69,3.69,0,0,0,2.618,6.29H78.679a3.69,3.69,0,0,0,2.618-6.29ZM50.1,11.216a2.369,2.369,0,0,1,2.367,2.367V15.9q-1.226-.117-2.463-.119c-.759,0-1.517.034-2.27.1v-2.3A2.369,2.369,0,0,1,50.1,11.216Z"></path>
      <path d="M57.755,81.029H42.245a3.093,3.093,0,0,0-3.093,3.093,10.848,10.848,0,0,0,21.7,0A3.093,3.093,0,0,0,57.755,81.029Z"></path>
    </g>
  </svg>
);

// functions --------------------------------------
export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function validateRequired(phone) {
  const re = /[a-zA-Z0-9-,]+/;
  return re.test(phone);
}

export function validatePassword(password) {
  const re =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return re.test(password);
}

export function setCookie(name, value, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}

export function getCookie(name) {
  let nameString = `${name}=`;
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(nameString) === 0) {
      return c.substring(nameString.length, c.length);
    }
  }
  return "";
}

export function checkCookie(name) {
  let cname = getCookie(name);
  if (cname !== "") {
    return true;
  } else {
    return false;
  }
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
